// // import React, { useEffect, useState } from "react";
// // import "../ProductCategory/productCategory.scss";
// // import Form from "react-bootstrap/Form";
// // import axios from "axios";
// // import { useNavigate } from "react-router-dom";
// // import { API_BASE_URL } from "../../../utils/index";
// // import Swal from "sweetalert2/dist/sweetalert2.js";
// // import { useAuthHeaders } from "../../../components/Token";
// // import CancelButton from "../../../components/MinorComponents/CancelButton";

// // function SubProductCategory() {
// //   const [categories, setCategories] = useState([]);
// //   const [category, setcategory] = useState("");
// //   const [subcategoryname, setsubcategoryname] = useState("");
// //   const [isSuccess, setIsSuccess] = useState(false);

// //   const navigate = useNavigate();
// //   const headers = useAuthHeaders();

// //   useEffect(() => {
// //     axios
// //       .get(`${API_BASE_URL}/getallcategory`,{

// //       }, { headers })
// //       .then((response) => {
// //         console.log(response.data.data,">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<<<<<<<<<<<<<")

// //         console.log(response,"++++++++++++++++++++++++++++")
// //         setCategories(response.data.data);
// //       })
// //       .catch((error) => {
// //         console.error("Error fetching category data:", error);
// //       });
// //   }, []);

// //   const handleFormSubmit = (e) => {
// //     e.preventDefault();
// //     axios
// //       .post(
// //         `${API_BASE_URL}/subcategory`,
// //         {
// //           category: category,
// //           subcategoryname: subcategoryname,
// //         },
// //         {
// //           headers,
// //         }
// //       )
// //       .then((response) => {
// //         console.log(response.data.data,"__________________________")
// //         console.log(response,">>>>>>>>>>>>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<")
// //         setIsSuccess(true);
// //         Swal.fire({
// //           icon: "success",
// //           title: "SubCategory Create has been saved",
// //           showConfirmButton: false,
// //           timer: 1500,
// //         });
// //         navigate("/subCategory");
// //         // Clear the form and reset the state
// //         console.log("response", response);
// //         setsubcategoryname  ("");
// //         setcategory("");
// //       })
// //       .catch((error) => {
// //         console.error("Error adding sub-category:", error);
// //         setIsSuccess(false);
// //         Swal.fire({
// //           icon: "error",
// //           title: "Oops...",
// //           text: error.response.data.error,
// //         });
// //       });
// //   }

// //   return (
// //     <div className="p-4">
// //       <h2>Sub Category</h2>
// //       <form onSubmit={handleFormSubmit} className="category">
// //         <div className="row category-field">
// //           <div className="col-md-6">
// //             <label htmlFor="name" className="fs-6">
// //               Category Name:
// //             </label>
// //             <br />
// //             <Form.Select
// //               aria-label="Default select example"
// //               className="my-2"
// //               value={category}
// //               onChange={(e) => setcategory(e.target.value)}
// //               required
// //             >
// //               <option value="">Select a category</option>
// //               {categories.map((categor) => (
// //                 // console.log(categor,"category")
// //                 <option key={categor} value={categor}>
// //                   {categor}
// //                 </option>

// //               ))}
// //             </Form.Select>
// //           </div>

// //           <div className="col-md-6">
// //             <label htmlFor="name" className="fs-6">
// //               Sub Category Name:
// //             </label>
// //             <br />
// //             <input
// //               type="text"
// //               id="name"
// //               value={subcategoryname}
// //               onChange={(e) => setsubcategoryname(e.target.value)}
// //             />
// //           </div>
// //         </div>
// //         <div className="buttons">
// //           <button>Save</button>
// //           <CancelButton path="/subCategory" />
// //         </div>
// //       </form>
// //       {isSuccess && (
// //         <p className="text-danger">Sub category added successfully!</p>
// //       )}
// //     </div>
// //   );
// // }

// // export default SubProductCategory;
// // import React, { useEffect, useState } from "react";
// // import "../ProductCategory/productCategory.scss";
// // import Form from "react-bootstrap/Form";
// // import axios from "axios";
// // import { useNavigate } from "react-router-dom";
// // import { API_BASE_URL } from "../../../utils/index";
// // import Swal from "sweetalert2/dist/sweetalert2.js";
// // import { useAuthHeaders } from "../../../components/Token";
// // import CancelButton from "../../../components/MinorComponents/CancelButton";
// // import { Modal, Button} from "react-bootstrap";
// // import MenuItem from '@mui/material/MenuItem';
// // import TextField from '@mui/material/TextField';
// // function SubProductCategory() {
// //   const [categories, setCategories] = useState([]);
// //   const [category, setCategory] = useState("");
// //   const [subcategoryname, setSubcategoryname] = useState("");
// //   const [isSuccess, setIsSuccess] = useState(false);

// //   const navigate = useNavigate();
// //   const headers = useAuthHeaders();
// //   const [show, setShow] = useState(false);
// //   const handleShow = () => setShow(true);
// //   const handleClose = () => setShow(false);

// //   useEffect(() => {
// //     axios
// //       .get(`${API_BASE_URL}/getallcategory`, { headers })
// //       .then((response) => {
// //         console.log(response.data.data, "API Response");
// //         if (response.data && Array.isArray(response.data.data)) {
// //           setCategories(response.data.data);
// //         } else {
// //           console.error("Unexpected response structure:", response.data.data);
// //         }
// //       })
// //       .catch((error) => {
// //         console.error("Error fetching category data:", error);
// //       });
// //   }, [headers]);

// //   const handleCategoryCreation = (e) => {
// //     e.preventDefault();
// //     axios
// //       .post(
// //         `${API_BASE_URL}/subcategory
// // `,
// //         {
// //           subcategoryname: subcategoryname,
// //           category: category,
// //         },
// //         {
// //           headers,
// //         }
// //       )
// //       .then((response) => {
// //         console.log(response, "Post responseSSSSSSSSSSSSSSSSSSSSS");

// //         console.log(response,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFF")
// //         setIsSuccess(true);
// //         Swal.fire({
// //           icon: "success",
// //           title: "SubCategory Create has been saved",
// //           showConfirmButton: false,
// //           timer: 1500,
// //         });
// //         navigate("/subCategory");
// //         setSubcategoryname("");
// //         setCategory("");
// //       })
// //       .catch((error) => {
// //         console.error("Error adding sub-category:WWWWWWWWWWWWWWWWWWWWWWWWww", error);
// //         setIsSuccess(false);
// //         Swal.fire({
// //           icon: "error",
// //           title: "Oops...",
// //           text: error.response?.data?.error || "An error occurred",
// //         });
// //       });
// //   };

// //   return (
// //     <>

// //     <Button variant="warning" onClick={handleShow} >
// //         Create Category
// //       </Button>

// //       <Modal show={show} onHide={handleClose}>
// //         <Modal.Header closeButton>
// //           <Modal.Title className='text-center'>
// //             Create Category
// //             <h5 className='text-center ms-5'></h5>
// //           </Modal.Title>
// //         </Modal.Header>
// //         <Form onSubmit={handleCategoryCreation}>
// //           <Modal.Body>
// //             <Form.Group controlId="formCategoryName">
// //               <Form.Label >Create Category Name</Form.Label>

// //              <br/>
// //             <TextField
// //           // id="outlined-select-currency"
// //           select
// //           label="Select a category"
// //           onChange={(e) => setCategory(e.target.value)}
// //          value={category}
// //           helperText="Please select your category"
// //           required
// //         >
// //           {categories.length > 0 &&
// //           categories.map((option) => (
// //             <MenuItem key={option._id} value={option._id}>
// //               {option.categoryname}
// //             </MenuItem>
// //           ))}
// //         </TextField>

// //             <TextField
// //             className="ms-2"
// //              id="subcategoryname"
// //           label="Sub Category Name"
// //           value={subcategoryname}
// //           onChange={(e) => setSubcategoryname(e.target.value)}
// //           required
// //         />

// //             </Form.Group>
// //           </Modal.Body>
// //           <Modal.Footer>
// //             <Button variant="secondary" onClick={handleClose} className="me-auto">
// //               Cancel
// //             </Button>
// //             <Button type="submit" variant="dark">
// //               Save
// //             </Button>
// //           </Modal.Footer>
// //         </Form>
// //         {isSuccess && (
// //         <p className="text-danger">Sub category added successfully!</p>
// //       )}
// //       </Modal>
// //     </>
// //   );
// // }

// // export default SubProductCategory;
// import { CiCircleRemove } from "react-icons/ci";
// import Dropzone from "react-dropzone";
// import React, { useEffect, useState } from "react";
// import "../ProductCategory/productCategory.scss";
// import Form from "react-bootstrap/Form";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../../../utils/index";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { useAuthHeaders } from "../../../components/Token";
// import { Modal, Button } from "react-bootstrap";
// import MenuItem from "@mui/material/MenuItem";
// import TextField from "@mui/material/TextField";
// import { RxCross2 } from "react-icons/rx";






// function SubProductCategory() {
//   const [categories, setCategories] = useState([]);
//   const [category, setCategory] = useState("");
//   const [subcategoryname, setSubcategoryname] = useState("");
//   const [isSuccess, setIsSuccess] = useState(false);
//   const [previewImages, setPreviewImages] = useState([]);
//   const navigate = useNavigate();
//   const headers = useAuthHeaders();
//   const [show, setShow] = useState(false);
//   const handleShow = () => setShow(true);
//   const handleClose = () => setShow(false);
//   const [propertytypeimage, setpropertytypeimage] = useState("");
//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/getallcategory`, { headers })
//       .then((response) => {
//         console.log(response.data.data, "API Response");
//         if (response.data && Array.isArray(response.data.data)) {
//           setCategories(response.data.data);
//         } else {
//           console.error("Unexpected response structure:", response.data.data);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching category data:", error);
//       });
//   }, [headers]);

//   const handleCategoryCreation = (e) => {
//     e.preventDefault();
//     console.log("Headers:", headers); // Log headers for debugging

//     axios
//       .post(
//         `${API_BASE_URL}/subcategory`,
//         {
//           subcategoryname: subcategoryname,
//           category: category,
//           propertytypeimage,propertytypeimage,
//         },
//         {
//           headers,
//         }
//       )
//       .then((response) => {
//         console.log(response, "Post response");

//         setIsSuccess(true);
//         Swal.fire({
//           icon: "success",
//           title: "SubCategory Create has been saved",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//         navigate("/subCategory");
//         setSubcategoryname("");
//         setCategory("");
//       })
//       .catch((error) => {
//         console.error("Error adding sub-category:", error);
//         console.log("Response data:", error.response?.data); // Log additional error info
//         setIsSuccess(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response?.data?.error || "An error occurred",
//         });
//       });
//   };
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);

//     files.forEach((file) => {
//       const reader = new FileReader();

//       reader.onload = () => {
//         if (reader.readyState == 2) {
//           setPreviewImages((oldArray) => [...oldArray, reader.result]);
//           setpropertytypeimage((oldArray) => [...oldArray, file]);
//         }
//       };

//       reader.readAsDataURL(file);
//     });
//   };
//   const onDrop = (acceptedFiles) => {
//     // Limiting to a maximum of 10 images

//     if (propertytypeimage.length + acceptedFiles.length <= 10) {
//       setpropertytypeimage([...propertytypeimage, ...acceptedFiles]);
//     } else {
//       alert("You can upload a maximum of 10 photos");
//     }

//     const files = Array.from(acceptedFiles.target.files);

//     files.forEach((file) => {
//       const reader = new FileReader();

//       reader.onload = () => {
//         if (reader.readyState == 2) {
//           setPreviewImages((oldArray) => [...oldArray, reader.result]);
//           setpropertytypeimage((oldArray) => [...oldArray, file]);
//         }
//       };

//       reader.readAsDataURL(file);
//     });
//     // setSeoKeywords(.filter((tag, index) => index !== i));
//   };
//   const handleDelete = (i) => {
//     setpropertytypeimage(propertytypeimage.filter((_, index) => index !== i));
//     setPreviewImages(previewImages.filter((_, index) => index !== i));
//   };

//   return (
//     <>
//       <Button variant="warning" onClick={handleShow}>
//         Create Property Type
//       </Button>

//       <Modal show={show} onHide={handleClose}>
//         <Modal.Header className="text-center">
//           <Modal.Title className="m-auto fw-bold ">
//             Create Property Type Name
//           </Modal.Title>
//         </Modal.Header>
//         <Form onSubmit={handleCategoryCreation}>
//           <Modal.Body>
//             <Form.Group controlId="formCategoryName" className="text-center">
//               <div className="">
//                 <TextField
//                   select
//                   label="Select a Type"
//                   onChange={(e) => setCategory(e.target.value)}
//                   value={category}
//                   required
//                   className="m-auto w-100 "
//                 >
//                   {categories.length > 0 &&
//                     categories.map((option) => (
//                       <MenuItem key={option._id} value={option._id}>
//                         <span>{option.categoryname}</span>
//                       </MenuItem>
//                     ))}
//                 </TextField>
//               </div>
//               <div className="text-center">
//                 <TextField
//                   className="m-auto mt-2 w-100"
//                   id="subcategoryname"
//                   label=" Enter a property type"
//                   value={subcategoryname}
//                   onChange={(e) => setSubcategoryname(e.target.value)}
//                   required
//                 />
//               </div>
//               <div className="form-group">
//                 <label className="label">Property Images </label>
//                 <Dropzone onDrop={onDrop}>
//                   {({ getRootProps, getInputProps }) => (
//                     <div {...getRootProps()} className="dropzone">
//                       <input
//                         {...getInputProps()}
//                         type="file"
//                         onChange={handleFileChange}
//                       />
//                       <p>
//                         Drag 'n' drop some files here, or click to select files
//                       </p>
//                     </div>
//                   )}
//                 </Dropzone>

              

//                 <div className="images-preview">
//                   {propertytypeimage.map((file, index) => (
//                     <>
                    
                    
//                     <img
//                       key={index}
//                       src={URL.createObjectURL(file)}
//                       alt={`preview-${index}`}
//                       className="image-preview"
//                     />
//                     <span className="ReactTags__remove" onClick={() => handleDelete(index)}>
//                     <RxCross2 />
//                   </span>
//                     </>
//                   ))}
//                 </div>
//               </div>
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer style={{ justifyContent: "center" }}>
//             <Button variant="warning" onClick={handleClose}>
//               Cancel
//             </Button>
//             <Button type="submit" variant="dark">
//               Save
//             </Button>
//           </Modal.Footer>
//         </Form>
//         {isSuccess && (
//           <p className="text-danger">Sub category added successfully!</p>
//         )}
//       </Modal>
//     </>
//   );
// }

// export default SubProductCategory;
import React, { useEffect, useState } from "react";
import "../ProductCategory/productCategory.scss";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../utils/index";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useAuthHeaders } from "../../../components/Token";
import { Modal, Button } from "react-bootstrap";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Dropzone from "react-dropzone";
import { RxCross2 } from "react-icons/rx";

function SubProductCategory() {
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [subcategoryname, setSubcategoryname] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [propertytypeimage, setPropertytypeimage] = useState([]);
  const navigate = useNavigate();
  const headers = useAuthHeaders();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/getallcategory`, { headers })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          setCategories(response.data.data);
        } else {
          console.error("Unexpected response structure:", response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching category data:", error);
      });
  }, [headers]);

  const handleCategoryCreation = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("category", category);
    formData.append("subcategoryname", subcategoryname);
    propertytypeimage.forEach((file, index) => {
      formData.append("propertytypeimage", file);
    });

    axios
      .post(`${API_BASE_URL}/subcategory`, formData, { headers })
      .then((response) => {
        setIsSuccess(true);
        Swal.fire({
          icon: "success",
          title: "SubCategory Create has been saved",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/subCategory");
        setSubcategoryname("");
        setCategory("");
        setPreviewImages([]);
        setPropertytypeimage([]);
      })
      .catch((error) => {
        console.error("Error adding sub-category:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.error || "An error occurred",
        });
      });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setPreviewImages([]);
    setPropertytypeimage(files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setPreviewImages((oldArray) => [...oldArray, reader.result]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const onDrop = (acceptedFiles) => {
    setPropertytypeimage([...propertytypeimage, ...acceptedFiles]);
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setPreviewImages((oldArray) => [...oldArray, reader.result]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const handleDelete = (index) => {
    setPropertytypeimage(propertytypeimage.filter((_, i) => i !== index));
    setPreviewImages(previewImages.filter((_, i) => i !== index));
  };

  return (
    <>
      <Button variant="warning" onClick={handleShow}>
        Create Property Type
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="text-center">
          <Modal.Title className="m-auto fw-bold">
            Create Property Type Name
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleCategoryCreation}>
          <Modal.Body>
            <Form.Group controlId="formCategoryName" className="text-center">
              <div className="">
                <TextField
                  select
                  label="Select a Type"
                  onChange={(e) => setCategory(e.target.value)}
                  value={category}
                  required
                  className="m-auto w-100"
                >
                  {categories.length > 0 &&
                    categories.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.categoryname}
                      </MenuItem>
                    ))}
                </TextField>
              </div>
              <div className="text-center">
                <TextField
                  className="m-auto mt-2 w-100"
                  id="subcategoryname"
                  label="Enter a property type"
                  value={subcategoryname}
                  onChange={(e) => setSubcategoryname(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label className="label">Property Images</label>
                <Dropzone onDrop={onDrop}>
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className="dropzone">
                      <input {...getInputProps()} type="file" onChange={handleFileChange} multiple />
                      <p>Drag 'n' drop some files here, or click to select files</p>
                    </div>
                  )}
                </Dropzone>
                <div className="images-preview">
                  {previewImages.map((src, index) => (
                    <div key={index} className="image-preview-wrapper">
                      <img src={src} alt={`preview-${index}`} className="image-preview" />
                      <span className="ReactTags__remove" onClick={() => handleDelete(index)}>
                        <RxCross2 />
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: "center" }}>
            <Button variant="warning" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" variant="dark">
              Save
            </Button>
          </Modal.Footer>
        </Form>
        {isSuccess && (
          <p className="text-danger">Sub category added successfully!</p>
        )}
      </Modal>
    </>
  );
}

export default SubProductCategory;
